import { ApiCore } from "../../utilities/core";

const url = 'api/edge/office/get_saved_filters';


export const apiSavedFilters = new ApiCore({
    get: true,
    post: true,
    url: url
});

// apiRecentSearches.massUpdate = () => {
//   // Add custom api call logic here
// }